import {
  NOTIFY_COMPLETE_CHECKOUT_ERROR,
  NOTIFY_DUPLICATEPO_CHECKOUT_ERROR,
  PLACE_ORDER_ASYNC,
  PO_NUMBER_CHANGE
} from '../../GlobalStateContainer'

export function isPlaceOrderPending(state = false, action) {
  switch (action.type) {
    case PLACE_ORDER_ASYNC:
      return true;
    case NOTIFY_COMPLETE_CHECKOUT_ERROR:
      return false;
    case NOTIFY_DUPLICATEPO_CHECKOUT_ERROR:
      return false;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/PlaceOrder/placeOrderReducers.js